/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#faf9f6',
    fontSize: '10px',
  },
  /* topo | direita | inferior | esquerda */
  section: {
    margin: '20px',
    padding: 10,
    flexGrow: 1,
    backgroundColor: '#faf9f6',
    border: '1px solid #e6e5e1',
    borderRadius: '12px',
  },
  subSection: {
    border: '1px solid #e6e5e1',
    borderRadius: '12px',
    backgroundColor: '#FFF',
    marginBottom: '12px',
    paddingBottom: '10px',
    marginTop: '12px',
  },
  systemInformations: {
    flexDirection: 'column',
    marginBottom: '12px',
    marginLeft: '12px',
  },
  pdfTitle: {
    fontSize: '16px',
    color: '#4790d0',
    fontWeight: 1500,
    marginBottom: '16px',
    marginTop: '4px',
  },
  pdfsubTitle: {
    fontSize: '12px',
    fontWeight: 900,
    marginTop: '16px',
    marginLeft: '12px',
    marginBottom: '12px',
    color: '#4790d0',
  },
  results: {
    flexDirection: 'column',
    marginBottom: '12px',
    marginLeft: '16px',
  },
  loadName: {
    flexDirection: 'column',
    marginBottom: '12px',
    marginLeft: '16px',
  },
  filterAdvice: {
    flexDirection: 'column',
    marginBottom: '12px',
    color: '#64635f',
    marginLeft: '12px',
  },
});

function PdfFile({ state, results, loadsPhases, inverters }) {
  const {
    batteryAutonomy,
    batteryDischarge,
    batteryEfficiency,
    batteryTension,
    clientName,
    hsp,
    inverterVoltage,
    systemInformations,
    technicalName,
    invertersFilters,
    inverterCharger,
  } = state;

  const {
    totalLoadsEnergy,
    pvPower,
    batteryEnergy,
  } = results;

  const {
    systemPhasesNumber,
    phaseOnePower,
    phaseTwoPower,
    phaseThreePower,
    inverterPower,
    phaseOneLoads,
    phaseTwoLoads,
    phaseThreeLoads,
  } = loadsPhases;

  const resultList = [
    {
      name: 'Total load power',
      value: `${phaseOnePower + phaseTwoPower + phaseThreePower} W`,
    },
    {
      name: 'Number of System Phases',
      value: `${systemPhasesNumber}`,
    },
    {
      name: 'Number of inverters per phase',
      value: '1',
    },
    {
      name: 'Total number of inverters',
      value: `${systemPhasesNumber}`,
    },
    {
      name: 'Power of each inverter',
      value: `${inverterPower} W`,
    },
    {
      name: 'Total energy consumed per day',
      value: `${totalLoadsEnergy} Wh`,
    },
    {
      name: 'Photovoltaic System Power',
      value: `${pvPower} W`,
    },
    {
      name: 'Inverter Voltage',
      value: `${inverterVoltage} V`,
    },
    {
      name: 'Sun hours',
      value: `${hsp}`,
    },
    {
      name: 'System Autonomy',
      value: `${batteryAutonomy} hours`,
    },
    {
      name: 'Battery Bank Capacity',
      value: `${batteryEnergy} Ah`,
    },
    {
      name: 'Battery Bank Voltage',
      value: `${batteryTension} V`,
    },
    {
      name: 'Battery Bank Depth of Discharge',
      value: `${batteryDischarge} %`,
    },
    {
      name: 'Battery Bank Efficiency',
      value: `${batteryEfficiency} %`,
    },
  ];

  const phasesObj = [{
    name: 'One',
    loads: phaseOneLoads,
    totalPower: phaseOnePower,
  },
  {
    name: 'Two',
    loads: phaseTwoLoads,
    totalPower: phaseTwoPower,
  },
  {
    name: 'Three',
    loads: phaseThreeLoads,
    totalPower: phaseThreePower,
  },
  ];

  return (
    <Document>
      <Page size="A4" style={ styles.page }>
        <View style={ styles.section }>
          <Text style={ styles.pdfTitle }>
            Results
          </Text>
          <Text style={ styles.systemInformations }>
            { `• Costumer name: ${clientName} `}
          </Text>
          <Text style={ styles.systemInformations }>
            { `• Responsible Technician: ${technicalName} `}
          </Text>
          <Text style={ styles.systemInformations }>
            { `• Additional Information: ${systemInformations} `}
          </Text>
          <View style={ styles.subSection }>
            <Text style={ styles.pdfsubTitle }>
              Calculations
            </Text>
            { resultList.map(({ name, value }) => (
              <Text style={ styles.results } key={ `pdf-result-${name}` }>
                { `• ${name}: ${value} `}
              </Text>
            )) }
          </View>
          <View style={ styles.subSection }>
            <Text style={ styles.pdfsubTitle }>
              Suggested inverters
            </Text>
            { (invertersFilters && inverterCharger)
            && (
              <Text style={ styles.filterAdvice }>
                Warning: Filters Applied
              </Text>
            )}
            { inverters.map(({ name }) => (
              <Text style={ styles.results } key={ `pdf-inverter-${name}` }>
                { `• ${name}` }
              </Text>
            )) }
          </View>
        </View>
      </Page>
      <Page size="A4" style={ styles.page }>
        <View style={ styles.section }>
          <View style={ styles.subSection }>
            { phasesObj.map(({ name, loads, totalPower }) => (
              totalPower !== 0
              && (
                <>
                  <Text style={ styles.pdfsubTitle } key={ `pdf-phase-${name}` }>
                    { `Phase connected loads ${name}` }
                  </Text>
                  { loads.map((load) => (
                    <Text style={ styles.loadName } key={ `pdf-load-${name}` }>
                      { `• ${load.loadName}: ${load.loadPower} Watts, ${load.loadUse} hours of use per day` }
                    </Text>
                  ))}
                </>
              )
            )) }
          </View>
        </View>
      </Page>
    </Document>
  );
}

export default PdfFile;
